import { render, staticRenderFns } from "./PublicPacket.vue?vue&type=template&id=1cb76e08&"
import script from "./PublicPacket.vue?vue&type=script&lang=ts&"
export * from "./PublicPacket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports